import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { CONTACT_US_IF_FURTHER_HELP, getAccountSettingsCTA } from "./shared";

export const LoginEmailIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getAccountSettingsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getAccountSettingsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => LOGIN_EMAIL_TITLE(strictLocalize),
    getDescription: () => [
      LOGIN_EMAIL_DESCRIPTION_1(strictLocalize),
      LOGIN_EMAIL_DESCRIPTION_2(strictLocalize),
      CONTACT_US_IF_FURTHER_HELP(strictLocalize),
    ],
  };
};

const LOGIN_EMAIL_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Update Login Email",
    description: {
      text: "Title for the answer of updating login email",
    },
  });

const LOGIN_EMAIL_DESCRIPTION_1 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "You can change your login email address by clicking the user-icon button in the upper-right corner of the brand portal and selecting the “Account Settings“ option.",
  });

const LOGIN_EMAIL_DESCRIPTION_2 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "In the “My Account” tab, locate the “Personal Information“ section and type in the new login email address in the “Personal Email“ box. Lastly, click the “Save“ button to save changes made on this page.",
  });
